import styles from "../../../styles/component-styles/general/input.module.scss"
export function PrimaryButton({ children, onClick, disabled, style }) {
    return (<button onClick={onClick} disabled={disabled} className={styles.primaryButton} style={style}>
        {children}
    </button>);
}